// extracted by mini-css-extract-plugin
module.exports = {"container":"Template_container__3OGX1","header":"Template_header__1Kz5o","content":"Template_content__VF6oB"};